import colors from 'styles/js/colors';

const typeFace = {
  futuraBT125: {
    fontFamily: 'FuturaBT',
    fontSize: '1.25rem',
    fontStretch: ' normal',
    fontStyle: ' normal',
    letterSpacing: 'normal',
    color: colors.marineBlue,
  },
  futura125: {
    fontFamily: 'Futura',
    fontSize: '1.25rem',
    fontStretch: ' normal',
    fontStyle: ' normal',
    letterSpacing: 'normal',
    color: colors.marineBlue,
  },
  futuraBT1: {
    fontFamily: 'FuturaBT',
    fontSize: '1rem',
    fontStretch: ' normal',
    fontStyle: ' normal',
    letterSpacing: 'normal',
    color: colors.marineBlue,
  },
  futura1: {
    fontFamily: 'Futura',
    fontSize: '1rem',
    fontStretch: ' normal',
    fontStyle: ' normal',
    letterSpacing: 'normal',
    color: colors.marineBlue,
  },
  cabin875: {
    fontFamily: 'Cabin',
    fontSize: '0.875rem',
    fontStretch: ' normal',
    fontStyle: ' normal',
    letterSpacing: 'normal',
    color: colors.marineBlue,
  },
  cabin75: {
    fontFamily: 'Cabin',
    fontSize: '0.75rem',
    fontStretch: ' normal',
    fontStyle: ' normal',
    letterSpacing: 'normal',
    color: colors.marineBlue,
  },
  cabin1: {
    fontFamily: 'Cabin',
    fontSize: '1rem',
    fontStretch: ' normal',
    fontStyle: ' normal',
    letterSpacing: 'normal',
    color: colors.marineBlue,
  },
  link: {
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundImage: `linear-gradient(111deg, ${colors.azure}, ${colors.seafoamBlue});`,
    backgroundClip: 'text',
    fontWeight: 500,
    lineHeight: 1.43,
  },
  futuraBT875: {
    fontFamily: 'FuturaBT',
    fontSize: '0.875rem',
    fontStretch: ' normal',
    fontStyle: ' normal',
    letterSpacing: 'normal',
    color: colors.marineBlue,
  },
};

export default typeFace;
